import type { SchemaOf } from '../helpers';
import { objectSchemaOf, Joi, makeAllOptional } from '../helpers';
import type { IEnvConfig, IEnvConfigMap } from '../apps/envConfigs';
import { envConfigSchemaMap } from '../apps/envConfigs';

export interface IWebEnvConfig extends IEnvConfig {
  firebaseConfig: {};
  authUiConfig: {};
  firestoreSettings: {};

  voiceToTextServerBaseUrl: string;
  listeningServerBaseUrl: string;
  localServerBaseUrl: string;

  slack: {
    slackClientId: string;
    slackAuthUrl: string;
    slackRedirectUrl: string;
    slackAuthScope: string;
  };

  snapshotBucket: string;
}

const webEnvConfigSchemaMap: SchemaOf<IWebEnvConfig> = {
  ...envConfigSchemaMap,
  firebaseConfig: Joi.object().unknown(true).required(),
  authUiConfig: Joi.object().unknown(true).required(),
  firestoreSettings: Joi.object().unknown(true).required(),
  voiceToTextServerBaseUrl: Joi.string().uri().required(),
  listeningServerBaseUrl: Joi.string().uri().required(),
  localServerBaseUrl: Joi.string().uri().required(),

  slack: objectSchemaOf<IWebEnvConfig['slack']>({
    slackClientId: Joi.string().required(),
    slackAuthUrl: Joi.string().uri().required(),
    slackRedirectUrl: Joi.string().uri().required(),
    slackAuthScope: Joi.string().required(),
  }).required(),

  snapshotBucket: Joi.string().required(),
};

export const webEnvConfigSchema = objectSchemaOf<IEnvConfig>(
  webEnvConfigSchemaMap
);

export const webEnvConfigPartialSchemaMap = makeAllOptional(
  webEnvConfigSchemaMap
);

export const webEnvConfigPartialSchema = objectSchemaOf<IEnvConfig>(
  webEnvConfigPartialSchemaMap
);

export type IWebEnvConfigMap = IEnvConfigMap<IWebEnvConfig>;
